export const isLoading = state => state.loadingProcesses > 0
export const modalVisible = state => state.modalVisible
export const images = state => state.images
export const selectedImage = state => state.selectedImage